module.exports = __webpack_public_path__ + "img/BAU Seniors_Infographics_29.615def74.png";